// @flow

import axios from 'axios';
import merge from 'lodash/merge';
import conf from './conf';
import type { HttpResponseType } from '../types/http-response';
import type { ApiConstructorArgsType } from '../types/api';

export default class ApiBase {
  conf: typeof conf;
  client: typeof axios;

  constructor(args: ApiConstructorArgsType = {}) {
    this.conf = merge({}, conf, args.conf);
    this.client = args.client || axios;
  }

  get(url: string, options: Object = {}): Promise<HttpResponseType> {
    return this.client.get(url, options);
  }

  post(url: string, payload: any, options: Object = {}): Promise<HttpResponseType> {
    return this.client.post(url, payload, options);
  }

  put(url: string, payload: any, options: Object = {}): Promise<HttpResponseType> {
    return this.client.put(url, payload, options);
  }

  delete(url: string, options: Object = {}): Promise<HttpResponseType> {
    return this.client.delete(url, options);
  }
}
